<template>
  <white-bg>
    <preload-content :loading="!list" min-height="300px">
      <template v-if="list">
        <h3>История событий</h3>
        <tabs :tabs="tabs" @changeTab="changeTab"/>
        <div class="story" :key="date" v-for="(item, date) in list">
          <div class="item">
            <h4>{{ date }}</h4>
            <div class="wrap" v-for="invoice in item.invoices" :key="invoice.id">
              <div class="title">
                <div class="name">
                  {{ invoice.description }}
                </div>
                <div class="master">
                  <span v-if="invoice.specialization" style="margin-right: 5px">{{ invoice.specialization.name }}</span>
                  <span v-if="invoice.coworking">{{ invoice.coworking.name }}</span>
                </div>
              </div>
              <div class="cash" :class="{profit: invoice.income}">
                <span v-if="parseInt(invoice.total_sum)">{{ invoice.income ? '+' : '-' }}</span> {{ round(invoice.total_sum) }}
              </div>
            </div>
          </div>
        </div>
        <button v-if="page !== last_page" @click="more()">Показать еще</button>
        <h3 v-if="list && !Object.keys(list).length" style="text-align: center">Список пуст</h3>
      </template>
    </preload-content>
  </white-bg>
</template>

<script>
import WhiteBg from '@/components/ui/white-bg'
import Tabs from '@/components/functional/Tabs'
import PreloadContent from '@/components/ui/preload-content';

export default {
  name: "History",
  components: {WhiteBg, Tabs, PreloadContent},
  props: {
    period: Object,
  },
  data() {
    return {
      page: 1,
      last_page: 1,
      type: null,
      history: null,
      tabs: [
        {name: 'Все', isActive: true, type: ''},
        {name: 'Доходы', isActive: false, type: 'income'},
        {name: 'Расходы', isActive: false, type: 'outcome'},
      ],
    }
  },
  computed: {
    filter() {
      return Object.assign({page: this.page, type: this.type}, this.period);
    },
    list() {
      if (!this.history) return null;
      let itm = {};
      this.history.forEach((val) => {
        let date = this.$moment(val.paid_at, 'YYYY-MM-DD HH:mm:ss').format('D MMMM, dddd');
        if (!itm[date]) itm[date] = {invoices: []};
        itm[date].invoices.push(val);
      });
      return itm;
    },
  },
  watch: {
    type(to) {
      this.type = to;
      this.page = 1;
      this.last_page = 1;
      this.loadHistory();
    },
    'period.start'() {
      this.page = 1;
      this.last_page = 1;
      this.loadHistory();
    },
  },
  mounted() {
    this.$moment().locale('ru');
    this.changeTab(0);
  },
  methods: {
    round(number) {
      return Math.round(number);
    },
    loadHistory(more = false) {
      this.$api.master.analytic.history.list(this.filter).then((data) => {
        this.page = data.meta.current_page;
        this.last_page = data.meta.last_page;
        more ? data.data.forEach((val) => this.history.push(val)) : this.history = data.data;
      })
    },
    changeTab(idx) {
      this.tabs = this.tabs.map((tab, tabIdx) => {
        tab.isActive = idx === tabIdx;
        if (tab.isActive) this.type = tab.type;
        return tab;
      });
    },
    more() {
      this.page = this.page + 1;
      this.loadHistory(true);
    }
  },
}
</script>

<style scoped lang="scss">
h3 {
  margin-top: -15px;
  padding-bottom: 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #383838;
}

h4 {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #808080;
}

.story {
  .item {

    h4 {
      font-weight: 600;
      margin-top: 30px;
    }

    .wrap {
      margin-top: 5px;
      margin-bottom: 10px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .name {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: #383838;
      }

      .master {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 20px;
        color: #808080;
      }

      .cash {
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        text-align: right;
        color: #383838;

        &.profit {
          color: #0F8A84;

        }
      }
    }
  }
}

button {
  width: 100%;
  height: 50px;
  background: initial;
  border: 2px solid #DBBFA7;
  box-sizing: border-box;
  border-radius: 5px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #383838;
  margin-top: 20px;
}
</style>
